import axios from '../base/axios';
import API_KEY from './key';

const GET_TVTOPRATED = 'flixfrenzy/redux/GET_TVTOPRATED';

// eslint-disable-next-line default-param-last
const tvTopRatedReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVTOPRATED:
      return action.payload;
    default:
      return state;
  }
};

export const getTvTopRated = () => (dispatch) => {
  axios.get(`tv/top_rated?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVTOPRATED,
      payload: res.data,
    });
  });
};

export default tvTopRatedReducer;
